import isEmpty from 'lodash/isEmpty';
import { MAX_CLUSTER_LAYER_ZOOM, SOURCES } from './map-constants';

export class MapSourceMgr {
  constructor(mapInstance) {
    if (!mapInstance) {
      throw new Error(
        'MapSourceMgr cannot be instantiated without a mapInstance'
      );
    }
    this.mapInstance = mapInstance;
  }

  mapInstance = null;

  addPropertyListSource(propertyListGeojson, { disableClustering } = {}) {
    if (!this.mapInstance.getSource(SOURCES.PROPERTY_LIST)) {
      this.mapInstance.addSource(SOURCES.PROPERTY_LIST, {
        type: 'geojson',
        data: propertyListGeojson,
        ...(!disableClustering && {
          cluster: true,
          clusterMaxZoom: MAX_CLUSTER_LAYER_ZOOM, // Max zoom to cluster points on
          clusterRadius: 40,
        }),
      });
    } else {
      this.mapInstance
        .getSource(SOURCES.PROPERTY_LIST)
        .setData(propertyListGeojson);
    }
  }

  addShapeFileSource(shapeFile) {
    if (
      !this.mapInstance.getSource(SOURCES.SHAPE_FILE) &&
      !isEmpty(shapeFile)
    ) {
      this.mapInstance.addSource(SOURCES.SHAPE_FILE, {
        type: 'geojson',
        data: {
          type: 'Feature',
          geometry: shapeFile,
        },
      });
    }
  }

  addZoningSource(zoningFiles) {
    if (!isEmpty(zoningFiles)) {
      for (let i = 0; i < zoningFiles.length; i++) {
        if (this.mapInstance.getSource(`${SOURCES.ZONING_FILE}_${i}`)) continue; // eslint-disable-line
        this.mapInstance.addSource(`${SOURCES.ZONING_FILE}_${i}`, {
          type: 'geojson',
          data: zoningFiles[i],
        });
      }
    }
  }
}
